import { useAppSelector } from 'redux/store';
import { ExpandedHeaderFieldsFragment } from 'api/graphql-types';
import { Icon } from 'components/icon/icon';
import { Button, IButtonVariants } from 'components/button';
import { Breadcrumb } from 'components/breadcrumb/breadcrumb';
import { Typography } from 'components/typography';
import { getStrapiButtonIconProps } from 'utils/get-strapi-button-icon';
import Image from 'components/image';
import UrlToSvg from 'components/url-to-svg/url-to-svg';

import styles from './expanded-header.module.scss';

export interface IExpandedHeaderProps {
	module?: ExpandedHeaderFieldsFragment;
	slug: string;
}

const ExpandedHeader = (props: IExpandedHeaderProps): React.JSX.Element => {
	let buttonVariant: string = props.module?.headerButton?.variant as string;
	if (props?.module?.headerButton?.variant === 'primary') {
		buttonVariant = 'primary-light';
	} else if (props?.module?.headerButton?.variant === 'secondary') {
		buttonVariant = 'secondary-light';
	}
	const { url: headerButtonIconUrl, position: headerButtonIconPos } = getStrapiButtonIconProps(
		props.module?.headerButton
	);

	const { showNeutralStyle } = useAppSelector((state) => state.settings);

	return (
		<div className={styles.homepageHeader}>
			<div className={styles.container}>
				<div>
					{props.module?.headerImage?.data?.attributes?.url && (
						<div className={styles.topHeader}>
							<div className={styles.headerImage}>
								{props.module.headerImage?.data?.attributes?.url && (
									<Image
										className={styles.backgroundImage}
										attributes={props.module.headerImage.data?.attributes}
										style={{ objectFit: 'cover' }}
										sizes="(max-width: 560px) 520px, (max-width: 1200px) 1185px, 840px"
										priority
										fill
									/>
								)}
								{!showNeutralStyle && (
									<div className={styles.bars}>
										<div />
										<div />
										<div />
									</div>
								)}
								<Typography tag="h1" className={styles.title}>
									{props.module.headerTitle}
								</Typography>
								{!showNeutralStyle && (
									<div className={styles.sidebars}>
										<div />
										<div />
										<div />
										<div />
									</div>
								)}
							</div>
							<div className={styles.content}>
								<div className={styles.description}>{props.module.headerDescription}</div>

								{props.module?.headerButton && (
									<div className={styles.button}>
										<Button
											fullWidth
											variant={buttonVariant as unknown as IButtonVariants}
											title={
												props.module.headerButton?.href?.text ||
												props.module.headerButton?.title ||
												props.module.headerButton?.href?.linkText
											}
											href={props.module?.headerButton?.href?.url || props.module?.headerButton?.href?.linkUrl || '#'}
											icon={
												headerButtonIconUrl && <Icon customIcon={<UrlToSvg url={headerButtonIconUrl} />} size="14px" />
											}
											iconPosition={headerButtonIconPos}
										/>
									</div>
								)}
							</div>
						</div>
					)}
					<div className={styles.subHeader}>
						<div className={styles.breadcrumb}>
							<Breadcrumb path={props.slug} />
						</div>
						<Typography tag="h2" className={styles.subHeaderTitle}>
							{props.module?.title}
						</Typography>
						<div className={styles.subHeaderDescription}>{props.module?.description}</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ExpandedHeader;
